import { useEffect, useState, type ReactNode } from "react"

import { Skeleton } from "@/components/ui/skeleton"
import { iniciarRestauracaoSessao } from "@/lib/sessao"

function BootstrapSkeleton() {
  return (
    <div className="flex min-h-svh items-center justify-center bg-background p-6">
      <div className="w-full max-w-md space-y-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
      </div>
    </div>
  )
}

/**
 * Aguarda a restauração da sessão (refresh + /me) apenas nas rotas que
 * realmente dependem de autenticação. Rotas públicas — como o preenchimento
 * de formulários — renderizam imediatamente, sem esperar o fluxo de sessão.
 */
export function SessionGate({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let ativo = true
    void iniciarRestauracaoSessao().finally(() => {
      if (ativo) setReady(true)
    })
    return () => {
      ativo = false
    }
  }, [])

  if (!ready) return <BootstrapSkeleton />
  return <>{children}</>
}
